var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"middlebg",style:({backgroundImage: 'url(' + _vm.imgurl + ')',
 backgroundSize:'contain',
 backgroundRepeat:'no-repeat',
 backgroundPosition:'center'})})}
var staticRenderFns = []

export { render, staticRenderFns }